import { nothing } from 'lit-html';
import { html } from 'lit-element';
import { KatalComponent, KatLitElement } from '../../shared/base';

import baseStyles from '../../shared/base/base.lit.scss';
import styles from './progressbar.lit.scss';

/**
 * @component {kat-progressbar} KatalProgressbar Used to indicate progress of an operation such as a download
 * @status Production
 * @theme flo
 * @example WithoutLabel {"value": 50,"variant":"primary"}
 * @example WithLabel {"value": 20, "label": "Loading . . .","variant":"primary"}
 * @example HistogramBar {"value": 77,"variant":"secondary"}
 */
export class Progressbar extends KatLitElement {
  static get properties() {
    return {
      /**
       * @classprop {string | number} value This is the percentage complete of the operation. Accepts 0-100
       */
      value: { type: Number, reflect: true },

      /**
       * @classprop {string} label This is the text to display in the progress bar. If attribute is missing the current value will be displayed.
       */
      label: { type: String, reflect: true },

      /**
       * @classprop {enum} variant This is the mode for the bar - Primary is default
       * @enum {value} primary Primary - Default
       * @enum {value} secondary Secondary
       */
      variant: { type: String, reflect: true },
    };
  }

  static get styles() {
    return [baseStyles, styles];
  }

  constructor() {
    super();

    this.variant = 'primary';
  }

  _normalizedProgress() {
    let progress = parseFloat(this.value);
    if (isNaN(progress) || progress < 0) {
      progress = 0;
    }
    if (progress > 100) {
      progress = 100;
    }
    return progress;
  }

  render() {
    const progress = this._normalizedProgress();
    const label = this.label;

    const labelEl = label ? html`<div class="label">${label}</div>` : nothing;

    const progressEl = progress
      ? html`<div class="meter" style=${`width: ${progress}%`}></div>`
      : nothing;

    return html`
      ${labelEl}
      <div class="wrapper">
        <div class="bar">${progressEl}</div>
        <span class="percent">${progress}%</span>
      </div>
    `;
  }
}

KatalComponent.register('kat-progressbar', Progressbar);
